import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const getAllowedGradesBySpecies = createSelector([(state: RootState) => state.lumberOptions], (lumberOptions) =>
  lumberOptions.state === 'loaded'
    ? mapValues(lumberOptions.allowedGradesBySpecies, (grades) => new Set(grades))
    : null,
);
